// auth.guard.ts
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

type MatchMode = 'any' | 'all';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    try {
        // 1) lazy init KC (idempotentno)
        await auth.ensureReady();

        // 2) nije prijavljen -> Kc login + prekini navigaciju
        if (!auth.isAuthenticated()) {
            await auth.login(state.url);       // vanjski redirect
            return false;                      // spriječi trenutnu navigaciju
        }

        // 3) role (opc.)
        const required: string[] = route.data?.['roles'] ?? [];
        const match: MatchMode = route.data?.['match'] ?? 'any';

        if (required.length) {
            const ok = match === 'all' ? auth.hasAllRoles(required) : auth.hasAnyRole(required);
            if (!ok) {
                // vrati UrlTree umjesto imperativne navigacije
                return router.createUrlTree(['/forbidden']);
            }
        }

        return true;
    } catch (e) {
        // fallback na login stranicu ako init/login pukne
        return router.createUrlTree(['/login'], { queryParams: { r: state.url } });
    }
};
